"use client";

import { CASINO_DATA_SOURCE, LIVE_CASINO_DATA_SOURCE, MAX_GAMES_PER_PAGE } from "@/config/casino";
import { getCasinoGroupsRequest, getLiveCasinoGroupsRequest } from "@/fe-core/_redux/actions/casinoActions";
import { getVendorsRequest } from "@/fe-core/_redux/actions/casinoVendorsActions";
import { getGamesPlatform } from "@/fe-core/helpers/casino";
import { IPromotionBannersResponseViewModel } from "@/fe-core/meta/interfaces/promotionBanners";
import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useScreen } from "../../context/ScreenContext";
import CasinoPromotionsSlider from "../CasinoPromotionsSlider";

const CasinoPage: FC<{
  children: JSX.Element[] | JSX.Element;
  backButton?: { href: string; text: string };
  banners: IPromotionBannersResponseViewModel | null;
}> = ({ children, banners }) => {
  const { isDesktop } = useScreen();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isDesktop !== null) {
      dispatch(
        getCasinoGroupsRequest({
          platform: getGamesPlatform(!isDesktop),
          dataSource: CASINO_DATA_SOURCE,
          pagination: {
            offset: 0,
            limit: MAX_GAMES_PER_PAGE,
          },
        })
      );
      dispatch(
        getLiveCasinoGroupsRequest({
          platform: getGamesPlatform(!isDesktop),
          dataSource: LIVE_CASINO_DATA_SOURCE,
          pagination: {
            offset: 0,
            limit: MAX_GAMES_PER_PAGE,
          },
        })
      );
      dispatch(getVendorsRequest({ platform: getGamesPlatform(!isDesktop) }));
    }
  }, [isDesktop]);

  return (
    <>
      <div className="">
        <div className="py-4">
          <CasinoPromotionsSlider banners={banners} />
        </div>
        {children}
      </div>
    </>
  );
};

export default CasinoPage;
